var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userInfo.nickname)?_c('span',{staticClass:"f-user-name"},[_vm._v(" "+_vm._s(_vm.userInfo.nickname)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }